const SEARCH_LANGUAGES_ENUM = {
    "fr" : "Français",
    "en" : "English",
    "" : "Toutes les langues"
};

const LANGUAGES_ENUM = {
    "fr" : "Français",
    "en" : "English",
    "es" : "Español",
    "de" : "Deutsch",
    "pl" : "Polski",
    "cs" : "Česky",
    "nl" : "Nederlands",
    "pt" : "Português",
    "it" : "Italiano",
    "la" : "Latine ; lingua latina",
    "" : "Indifférent"
};

const LANGUAGES_MAPPING = {
    "FRA" : "fr",
    "ENG" : "en",
    "SPA" : "es",
    "DEU" : "de",
    "POL" : "pl",
    "CZH" : "cs",
    "NLD" : "nl",
    "POR" : "pt",
    "ITA" : "it",
    "LAT" : "la"
}

export { SEARCH_LANGUAGES_ENUM, LANGUAGES_ENUM, LANGUAGES_MAPPING };